import type { SegmentClaimRecord } from "../types"

import { FileSearch } from "@/components/icons"

import { claimFieldPathLabel, claimFreshnessLabel } from "../utils/claim-display"

type ClaimCitationChipProps = {
  claim: SegmentClaimRecord
  onOpen: (claimId: string) => void
}

export function ClaimCitationChip({ claim, onOpen }: ClaimCitationChipProps) {
  const freshness = claimFreshnessLabel(claim.freshness)
  const fieldLabel = claimFieldPathLabel(claim.fieldPath)
  return (
    <button
      aria-label={`Open evidence for ${fieldLabel}`}
      className="btn-spring border-primary/25 bg-primary/10 text-primary hover:bg-primary/15 ml-2 inline-flex h-6 items-center gap-1 rounded-md border px-1.5 text-[10px] font-semibold uppercase transition"
      type="button"
      onClick={() => onOpen(claim.claimId)}
    >
      <FileSearch className="size-3" />
      {freshness}
    </button>
  )
}
